import { Colors } from '../../../../utils/resources/colors';
import { Resources } from '../../../../utils/resources/resources';
import { Strings } from 'src/com/sixdee/crbtportal/utils/resources/strings';

export class TransactionHistoryStatusColor
{
  
    static getStatusBackgroundColor(status: string, resources: Resources)
    {
        switch(status)
        {
          case resources.getString(Strings.ACTIVATED):
          {
            return resources.getColor(Colors.color_27);
          }

          case  resources.getString(Strings.DEACTIVATED):
              {
                  return  resources.getColor(Colors.color_28);
              }

           case resources.getString(Strings.RENEWED):
               {
                   return resources.getColor(Colors.color_27);
               }   
               default:
                {
                   return  resources.getColor(Colors.color_27);
               }
        }
    }
    
    
    static getStatusLabelColor(status:string, resources:Resources)
    {
        switch(status)
        {
            case resources.getString(Strings.ACTIVATED):
            {
                return resources.getColor(Colors.color_33);
            }

            case resources.getString(Strings.DEACTIVATED):
            {
                return resources.getColor(Colors.color_12);
            }
            case resources.getString(Strings.RENEWED):
                {
                    return resources.getColor(Colors.color_33);
                }
             default:
                 {
                     return resources.getColor(Colors.color_33);
                 }
        }
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/transactionhistory/transactionhistorystatuscolor.ts